import Tabswitch from "../../../../../layout/components/Tabswitch/Tabswitch";

function Header() {
  let tabData = [
    {
      tabName: "List",
      tabLink: "/admin/admin-users/list",
    },
    // {
    //   tabName: "Summary",
    //   tabLink: "/admin/admin-users/summary",
    // },
  ];

  return (
    <>
      <Tabswitch tabData={tabData} />
    </>
  );
}

export default Header;
